import React from 'react';
import PropTypes from 'prop-types';
import { H3 } from 'styled';

import Card from 'components/card';
import ArrowButton from 'components/buttons/ArrowButton';

import {StyledBlogSmallHeading} from 'components/blog/styled';

const RelatedArticles = ({isFR, relatedBlogArticlesArray, readMoreText}) => {

  return (
    <React.Fragment>
      <h3 style={{fontWeight: '400', fontSize: '21px', marginTop: '55px', marginBottom: '35px'}}> 
        {isFR ? "Contenu connexe": "Related content"}
      </h3>

      { relatedBlogArticlesArray.slice(0, 3).map((post) => { 

        const cardImageUrl = post?.data?.card_image?.url?.split('?')[0] || "https://images.prismic.io/privatefly/b73dbcd7-9d0d-4a3e-8520-bdf1794abdcb_blank_img_placeholder.jpeg?auto=compress,format";
        const cardHeading = post.data.card_title;
        const cardText = post.data.card_description && [post.data.card_description];
        const cardLink = `${post.data.url}`;

        const docPublishDate = post.data.date_published;
        const dateOptions = { day: '2-digit', month: 'long', year: 'numeric' };
        const datePublished = new Date(docPublishDate).toLocaleDateString(isFR ? "fr-fr" : "en-gb", dateOptions).split(' ');
        const relatedArticleDatePublished = `${datePublished[0]} ${datePublished[1]} ${datePublished[2]}`;

        return (
          <Card 
            headingText={
              <React.Fragment>
                <StyledBlogSmallHeading> {relatedArticleDatePublished} </StyledBlogSmallHeading>
                <H3 fontSize="21px"> {cardHeading} </H3>
              </React.Fragment>
            }
            cardText={cardText} 
            textAlign="left"
            buttonComponent={<ArrowButton buttonText={readMoreText} theme="blue" />}
            buttonAlign="flex-end"
            isCardLink={true}
            cardLink={cardLink}
            cardImageUrl={cardImageUrl}
            alignImage="left"
            desktopOneRowCard={true}
            isBlog={true}
            isFeaturedBlogCard={false}
          />
        ) 
      })}

    </React.Fragment>
  );
}

export default RelatedArticles;

RelatedArticles.propTypes = { 
   isFR: PropTypes.bool,
   readMoreText: PropTypes.string,
   relatedBlogArticlesArray: PropTypes.array,
};

